module.exports = __webpack_public_path__ + "img/ms_b2_pic4.a6fcfda2.png";